import type { IComponentOptions } from "angular";
import { ButtonComponent } from "App/Modules/Gui/Components/Button/Common/ButtonComponent";
import { ButtonComponentController } from "../Common/ButtonComponentController";

import "../Common/Button.scss";
import "./CancelButton.html";
import "./CancelButton.scss";

export class CancelButtonComponent extends ButtonComponent implements IComponentOptions {
    public controller = ButtonComponentController;

    public templateUrl = "/App/Modules/Gui/Components/Button/CancelButton/CancelButton.html";

    constructor() {
        super();

        this.bindings = {
            ...this.bindings,
            isTextMuted: "<?",
        };
    }
}
